import styled from "styled-components";

export const Container = styled.div`
 //margin: 3rem;

  /*@media (max-width: 800px) {
    margin: 1rem;
    display: flex;
    flex-direction: column;
  } */
`;

export const Title = styled.h1`
  font-family: Poppins;
  font-size: 2.9rem;
  line-height: 52px;
  font-weight: 600;
  height: 105px;

  @media (max-width: 800px) {
    font-size: 1.2rem;
    display: flex;
    flex: 1;
  }
`;

export const LeftSide = styled.div`
  position: relative;
  width: 33%;
  float: left;
  height: 70vh;
  z-index: 10;

  h3 {
    font-size: 1.5rem;
    margin: 0;
    font-weight: 600;
    font-family: Poppins;
    padding-bottom: 0.5rem;
  }

  h4 {
    font-family: Poppins;
    margin: 0;
    font-weight: normal;
    font-size: 1.5rem;
    padding-bottom: 0.75rem;
  }

  @media (max-width: 800px) {
    float: none;
    width: 100%;
    height: 55vh;
    h3 {
      font-size: 1.2rem;
    }
    h4 {
      font-size: 1rem;
    }
  }
`;

export const RightSide = styled.div`
  position: relative;
  width: 66%;
  float: left;
  height: 70vh;
  z-index: 10;
  border-left: 1px solid #222222;

  h3 {
    padding-left: 2rem;
    font-size: 1.5rem;
    margin: 0;
    font-weight: 600;
    font-family: Poppins;
    padding-bottom: 0.5rem;
  }

  h4 {
    font-family: Poppins;
    margin: 0;
    font-weight: normal;
    font-size: 1.5rem;
    padding-bottom: 0.75rem;
    padding-left: 2rem;
  }

  @media (max-width: 800px) {
    float: none;
    width: 100%;
    border: none;
    height: 57vh;

    h3 {
      font-size: 1.2rem;
      padding-left: 0;
    }
    h4 {
      font-size: 1rem;
      padding-left: 0;
    }
  }
`;

export const FlexDivLeft = styled.div`
  width: 50%;
  float: left;
  @media (max-width: 800px) {
    float: none;
    width: 100%;
    h3 {
      font-size: 1.2rem;
    }
    h4 {
      font-size: 1rem;
    }
  }
`;

export const FlexDivRight = styled.div`
  width: 50%;
  float: right;
  @media (max-width: 800px) {
    float: none;
    width: 100%;
    h3 {
      font-size: 1.2rem;
    }
    h4 {
      font-size: 1rem;
    }
  }
`;

export const BorderDiv = styled.div`
  position: absolute;
  top: 45%;
  padding-left: 2rem;

  h1 {
    margin: 0;
    font-family: Poppins;
    font-size: 2.25rem;
    font-weight: 600;
  }

  @media (max-width: 800px) {
    padding-left: 0;
    top: auto;
    float: none;
    width: 100%;
    h3 {
      font-size: 1.2rem;
    }
    h4 {
      font-size: 1rem;
    }
  }
`;

export const LeftDiv = styled.div`
  display: inline-block;
  width: 75%;
  @media (max-width: 800px) {
    float: none;
    width: 60%;
    h1 {
      font-size: 1rem;
    }
  }
`;

export const RightDiv = styled.div`
  display: inline-block;
  text-align: end;

  .gradienteH1 {
    background-color: #fcc046;
    background-image: linear-gradient(
      103.6deg,
      #fcc046 -13.96%,
      #cc2a55 58.95%,
      #bf1827 134.95%
    );
    background-size: 100%;
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
  }

  @media (max-width: 800px) {
    float: none;
    width: 40%;
    h1 {
      font-size: 1rem;
    }
  }
`;

export const BorderDivIn = styled.div`
  width: 55vw;
  /* border-radius: 10px;
  border: 3px solid blue; */
  padding: 1rem;
  border: 5px solid transparent;
  border-radius: 15px;
  background: linear-gradient(white, white) padding-box,
    /*this is your grey background*/
      linear-gradient(
        103.6deg,
        #fcc046 -13.96%,
        #cc2a55 58.95%,
        #bf1827 134.95%
      )
      border-box;

  @media (max-width: 800px) {
    float: none;
    width: 80%;
  }
`;

export const Check = styled.div`
  width: 66%;
  float: right;
  padding-bottom: 1rem;

  label {
    margin: 0;
    padding-left: 1rem;

    span {
      font-family: Poppins;
      font-size: 1.5rem;
      font-weight: 600;
      padding-left: 0.75rem;
    }

    input[type="checkbox"] {
      height: 1.1rem;
      width: 1.1rem;
      filter: grayscale(100%);
      cursor: pointer;
    }
  }

  @media (max-width: 800px) {
    float: none;
    width: 100%;

    label{
      padding-left: 0;

      span{
        font-size: 0.9rem;
      }
    }
  }
`;

export const ModalButton = styled.button`
  cursor: pointer;
  width: 100%;
  height: 4rem;
  border: none;
  border-radius: 10px;
  background-image: linear-gradient(
    103.6deg,
    #fcc046 -13.96%,
    #cc2a55 58.95%,
    #bf1827 134.95%
  );
  width: 65%;
  float: right;
  margin-bottom: 2rem;

  h1 {
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 2rem;
    text-align: center;
    color: white;
    margin: 0;
  }
  @media (max-width: 800px) {
    float: none;
    width: 100%;

    h1 {
      font-size: 1rem;
    }
  }

`;
